import { render } from "./HomeScreen.vue?vue&type=template&id=2931b926"
import script from "./HomeScreen.vue?vue&type=script&lang=js"
export * from "./HomeScreen.vue?vue&type=script&lang=js"

import "./HomeScreen.vue?vue&type=style&index=0&id=2931b926&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__